module.exports = __webpack_public_path__ + "static/img/sou_01.edcd859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sou_01.jpg
// module id = dgvE
// module chunks = 3